import React, { useState, useEffect } from 'react';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';

const MyPagination = ({ totalRecords, recordsPerPage, currentPage, onPageChange, filterData }) => {
    const [totalPages, setTotalPages] = useState(1);
    const [activePage, setActivePage] = useState(currentPage);

    useEffect(() => {
        const pages = Math.ceil(totalRecords / recordsPerPage);
        setTotalPages(pages);
    }, [totalRecords, recordsPerPage]);

    const handlePageClick = (pageNumber) => {
        setActivePage(pageNumber);
        onPageChange(pageNumber);
    };

    const renderPages = () => {
        const pageArray = [];
        const startPage = Math.max(activePage - 2, 1);
        const endPage = Math.min(activePage + 2, totalPages);

        if (startPage > 1) {
            pageArray.push(
                <PaginationItem key={1}>
                    <PaginationLink onClick={() => handlePageClick(1)}>1</PaginationLink>
                </PaginationItem>
            );
            if (startPage > 2) {
                pageArray.push(
                    <PaginationItem key="ellipsis-start" disabled>
                        <PaginationLink>...</PaginationLink>
                    </PaginationItem>
                );
            }
        }

        for (let i = startPage; i <= endPage; i++) {
            pageArray.push(
                <PaginationItem key={i} active={i === activePage}>
                    <PaginationLink onClick={() => handlePageClick(i)}>{i}</PaginationLink>
                </PaginationItem>
            );
        }

        if (endPage < totalPages) {
            if (endPage < totalPages - 1) {
                pageArray.push(
                    <PaginationItem key="ellipsis-end" disabled>
                        <PaginationLink>...</PaginationLink>
                    </PaginationItem>
                );
            }
            pageArray.push(
                <PaginationItem key={totalPages}>
                    <PaginationLink onClick={() => handlePageClick(totalPages)}>{totalPages}</PaginationLink>
                </PaginationItem>
            );
        }

        return pageArray;
    };

    useEffect(() =>{
        setActivePage(1)
        onPageChange(1);
    },[filterData?.search,filterData?.limit,filterData?.question_type, filterData?.randomEvent]);
    return (
        <Pagination className='pagination-main'>
            <PaginationItem disabled={activePage === 1}>
                <PaginationLink previous onClick={() => handlePageClick(activePage - 1)} />
            </PaginationItem>
            {renderPages()}
            <PaginationItem disabled={activePage === totalPages}>
                <PaginationLink next onClick={() => handlePageClick(activePage + 1)} />
            </PaginationItem>
        </Pagination>
    );
};

export default MyPagination;
